import { get } from 'lodash';

import store from '../../redux/store';

export function generateOtpWebViewUrl() {
  const language = get(store.getState(), 'setting.language', 'vi');

  const searchParams = new URLSearchParams();
  searchParams.append('app_id', CONFIG.OTP_OVER_SMS.APP_ID);
  searchParams.append('app_type', CONFIG.APP_TYPE);
  searchParams.append('client_type', 1);
  searchParams.append('api_version', 1);
  searchParams.append('client_version', CONFIG.CLIENT_VERSION.API);
  searchParams.append('client_id', '1.0');
  searchParams.append('client_language', language);
  searchParams.append('redirect_uri', window.location.href);

  const query = searchParams.toString();

  return `${CONFIG.OTP_OVER_SMS.HOST}${CONFIG.OTP_OVER_SMS.PATHNAME}?${query}`;
}

export function openOtpWebView() {
  const otpUrl = generateOtpWebViewUrl();
  const otpTitle = 'NOW Auth';

  const newWindow = window.open(otpUrl, otpTitle);
  if (window.focus) {
    newWindow.focus();
  }
}



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/utils.js